import { render, staticRenderFns } from "./liveTraining.vue?vue&type=template&id=30f8be94&scoped=true"
import script from "./liveTraining.vue?vue&type=script&lang=js"
export * from "./liveTraining.vue?vue&type=script&lang=js"
import style0 from "./liveTraining.vue?vue&type=style&index=0&id=30f8be94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f8be94",
  null
  
)

export default component.exports